import { Discount, Campaign } from '../../types/discounts';

export enum ActionTypes {
    FetchDiscounts = '[marketing/discounts] FETCH_DISCOUNTS',
    FetchDiscountsResponse = '[marketing/discounts] FETCH_DISCOUNTS_RESPONSE',
    FetchNextDiscountResponse = '[marketing/discounts] FETCH_NEXT_DISCOUNT_RESPONSE',
    FetchCampaigns = '[marketing/discounts] FETCH_CAMPAIGNS',
    FetchCampaignsResponse = '[marketing/discounts] FETCH_CAMPAIGNS_RESPONSE',
}

export enum FetchDiscountsReason {
    mount = 'mount',
    next = 'next',
    refresh = 'refresh',
}

export interface FetchDiscounts {
    type: ActionTypes.FetchDiscounts;
    payload: {
        accountId: string;
        params: URLSearchParams;
        reason: FetchDiscountsReason;
    };
}

export interface FetchDiscountsResponse {
    type: ActionTypes.FetchDiscountsResponse;
    payload: {
        discounts: Discount[];
    };
    meta: {
        cause: FetchDiscounts;
    };
}

export interface FetchCampaigns {
    type: ActionTypes.FetchCampaigns;
    payload: {
        accountId: string;
        params: URLSearchParams;
    };
}

export interface FetchCampaignsResponse {
    type: ActionTypes.FetchCampaignsResponse;
    payload: {
        campaigns: Campaign[];
    };
    meta: {
        cause: FetchCampaigns;
    };
}

export const fetchDiscounts = (
    accountId: string,
    params: URLSearchParams,
    reason: FetchDiscountsReason
): FetchDiscounts => {
    return {
        type: ActionTypes.FetchDiscounts,
        payload: {
            accountId,
            params,
            reason,
        },
    };
};

export const fetchCampaigns = (accountId: string, params: URLSearchParams): FetchCampaigns => {
    return {
        type: ActionTypes.FetchCampaigns,
        payload: {
            accountId,
            params,
        },
    };
};

export interface FetchNextDiscountResponse {
    type: ActionTypes.FetchNextDiscountResponse;
    payload: {
        discounts: Discount[];
    };
    meta: {
        cause: FetchDiscountsResponse;
    };
}

export type Actions =
    | FetchDiscounts
    | FetchDiscountsResponse
    | FetchNextDiscountResponse
    | FetchCampaigns
    | FetchCampaignsResponse;
